import { render, staticRenderFns } from "./organization-cost.vue?vue&type=template&id=90c1afd2&scoped=true&"
import script from "./organization-cost.vue?vue&type=script&lang=js&"
export * from "./organization-cost.vue?vue&type=script&lang=js&"
import style0 from "./organization-cost.vue?vue&type=style&index=0&id=90c1afd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c1afd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90c1afd2')) {
      api.createRecord('90c1afd2', component.options)
    } else {
      api.reload('90c1afd2', component.options)
    }
    module.hot.accept("./organization-cost.vue?vue&type=template&id=90c1afd2&scoped=true&", function () {
      api.rerender('90c1afd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-organization-management/organization-cost.vue"
export default component.exports